import { Container, Typography } from '@mui/material';

// Store is needed here to handle async load time race condition
// since the LoadingScreenContainer is not using code splitting,
// it must be loaded early.
import store from '../../../redux/store';

import useStyles from '../../../styling/jss';
import animation from '../../../assets/images/animationLoading.gif';
import intelyConnectText from '../../../assets/images/intelyConnectText.png';

import {
    getUserLogin,
    restoreUserSessionStates,
    redirectUserTokenExpired,
    updateUserLastRefreshTime,
    updateUserLastActivityTime,
    setupAuthUserDataWithStore,
    getDefaultOrganizationIdUrlParameter,
    getCurrentSelectedOrganizationId,
} from '../../../utils/loginUtils';
import { prepareAppDataGlobally } from '../../../hooks/usePrepareAppDataGloballyHook';
import { Cookies } from 'react-cookie';
import { CURRENT_ORGANIZATION_ID_KEY, CURRENT_DOMAIN_SUFFIX } from '../../../utils/constants';

const LoadingScreenContainer = () => {
    const classes = useStyles()();

    window.onload = async function () {
        const cookies = new Cookies();
        const urlParameterOrganizationId = getDefaultOrganizationIdUrlParameter();
        const hasLoadedOrganizationIdFromUrlParameters = !!urlParameterOrganizationId;

        // Set the current organization ID from the ULR Parameter or from local storage
        const defaultOrganizationId = urlParameterOrganizationId || getCurrentSelectedOrganizationId();
        if (defaultOrganizationId) {
            localStorage.setItem(CURRENT_ORGANIZATION_ID_KEY, defaultOrganizationId);
        }

        // Validate the user token and get the user login data
        const loginResults = await getUserLogin();

        // Get the current organization ID from the user token if it was not set from the URL or local storage
        if (!defaultOrganizationId) {
            localStorage.setItem(CURRENT_ORGANIZATION_ID_KEY, loginResults.defaultOrganizationId);
        }

        cookies.set(CURRENT_ORGANIZATION_ID_KEY, localStorage.getItem(CURRENT_ORGANIZATION_ID_KEY), {
            path: '/',
            domain: CURRENT_DOMAIN_SUFFIX,
            secure: true,
        });

        // Remove currentOrganizationId from the URL if it was set from the URL
        if (hasLoadedOrganizationIdFromUrlParameters) {
            const params = new URLSearchParams(window.location.search);
            params.delete('currentOrganizationId');
            window.location.replace(window.location.pathname + (params.toString() ? '?' + params : ''));
            return;
        }

        if (loginResults !== false) {
            await setupAuthUserDataWithStore(store, loginResults);

            prepareAppDataGlobally();

            updateUserLastRefreshTime();
            updateUserLastActivityTime();
            restoreUserSessionStates();
        } else {
            redirectUserTokenExpired();
        }
    };

    return (
        <Container
            component="main"
            maxWidth="xs"
            style={{
                height: '-webkit-fill-available',
                display: 'flex',
                alignItems: 'center',
                overflow: 'auto',
                marginTop: '4rem',
                padding: '0 10px',
                justifyContent: null,
            }}
        >
            <div className={classes.bottomdiv} style={{ wordBreak: 'break-all' }}>
                <img src={animation} alt="img2 Icon" />
                <Typography>
                    <img src={intelyConnectText} style={{ width: '100%' }} alt="connecttext Icon" />
                </Typography>
            </div>
        </Container>
    );
};

export default LoadingScreenContainer;
